import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
    [ModulesConfigMap[ModulesMap.POSITIONS_MACHINES].GET_POSITIONS_MACHINES]: {
        url: '/company/:companyId/positions/machines/',
    },

    [ModulesConfigMap[ModulesMap.POSITIONS_MACHINES].GET_POSITIONS_MACHINE]: {
        url: '/company/:companyId/positions/machines/:machineId/',
    },

    [ModulesConfigMap[ModulesMap.POSITIONS_MACHINES].GET_POSITIONS_ON_TIME_POINT]: {
        url: '/company/:companyId/positions/machines/on_time/:machineId/',
    },

}